import { useNavigate } from 'react-router-dom';
import { useAppStore } from '@/store/AppStore';

interface Kpi {
  label: string;
  sub: string;
  value: number;
  path: string;
  icon: string;
  iconClass: string;
}

export default function KpiCards() {
  const { requests, quotes, appointments, jobs } = useAppStore();
  const navigate = useNavigate();

  const newRequests = requests.filter((r) => r.status === 'Yeni Talep').length;
  const videoWaitingQuote = requests.filter(
    (r) => r.videoStatus === 'Video Geldi' && ['Video Geldi', 'Değerlendiriliyor', 'Teklif Hazırlanacak'].includes(r.status),
  ).length;
  const awaitingReply = quotes.filter((q) => q.status === 'Cevap Bekleniyor').length;
  const approvedNoAppointment = quotes.filter(
    (q) => q.status === 'Onaylandı' && !appointments.some((a) => a.quoteId === q.id),
  ).length;
  const todaysAppointments = appointments.filter((a) => a.date === '26 Ağustos 2026').length;
  const todaysJobs = jobs.filter((j) => j.date === '26 Ağustos 2026').length;

  const kpis: Kpi[] = [
    {
      label: 'Bugünkü İşler',
      sub: 'Bugün planlanan iş',
      value: todaysJobs,
      path: '/bugunun-isleri',
      icon: 'ri-calendar-check-line',
      iconClass: 'bg-primary-50 text-primary-600',
    },
    {
      label: 'Yeni Talepler',
      sub: 'Henüz işlenmemiş',
      value: newRequests,
      path: '/teklif-talepleri',
      icon: 'ri-file-list-3-line',
      iconClass: 'bg-primary-50 text-primary-600',
    },
    {
      label: 'Video Geldi — Teklif Yok',
      sub: 'Aksiyon gerektiriyor',
      value: videoWaitingQuote,
      path: '/teklif-talepleri',
      icon: 'ri-video-line',
      iconClass: 'bg-accent-100 text-accent-700',
    },
    {
      label: 'Cevap Bekleyen Teklif',
      sub: 'Müşteri yanıtı bekleniyor',
      value: awaitingReply,
      path: '/teklifler',
      icon: 'ri-chat-3-line',
      iconClass: 'bg-amber-50 text-amber-600',
    },
    {
      label: 'Onaylandı — Randevu Yok',
      sub: 'Randevuya bağlanmalı',
      value: approvedNoAppointment,
      path: '/teklifler',
      icon: 'ri-calendar-event-line',
      iconClass: 'bg-red-50 text-red-600',
    },
    {
      label: 'Bugünkü Randevular',
      sub: 'Bugünün takvimi',
      value: todaysAppointments,
      path: '/randevu',
      icon: 'ri-calendar-line',
      iconClass: 'bg-accent-100 text-accent-700',
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {kpis.map((kpi) => (
        <button
          key={kpi.label}
          type="button"
          onClick={() => navigate(kpi.path)}
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-white p-4 text-left transition-colors hover:border-primary-200 hover:bg-background-50"
        >
          <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${kpi.iconClass}`}>
            <i className={`${kpi.icon} text-xl`} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-heading text-2xl font-bold leading-none text-foreground-950">
              {kpi.value}
            </div>
            <div className="mt-1 truncate text-[13px] font-semibold text-foreground-800">{kpi.label}</div>
            <div className="truncate text-[11px] text-foreground-500">{kpi.sub}</div>
          </div>
          <i className="ri-arrow-right-s-line text-lg text-foreground-300 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" />
        </button>
      ))}
    </div>
  );
}